import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  PROVIDER_FORM_FIELD_NAME_OPENING_HOURS,
  PROVIDER_FORM_OPENING_HOURS_FIELD_MAX_LENGTH,
} from '../../ProviderForm.constants'

function OpeningHoursField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Provider.OpeningHoursFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={PROVIDER_FORM_OPENING_HOURS_FIELD_MAX_LENGTH}
      name={PROVIDER_FORM_FIELD_NAME_OPENING_HOURS}
      placeholder={t('Provider.OpeningHoursFieldPlaceholderKey')}
    />
  )
}

export default OpeningHoursField
